import WarsidahaCilmigaXoolaha2025 from "./cover/WarsidahaCilmigaXoolaha2025.PNG"
import A1 from "./journals/WarsidahaCilmigaXoolaha2025.pdf";

import SSRN_IMG from "./cover/ssrn.jpeg";
import SSRN_FILE from "./journals/ssrn6406619.pdf";

import SR26G from "./cover/SR26.PNG"
import SR26F from "./journals/SR26.pdf";

import SR27G from "./cover/SR27.PNG"
import SR27F from "./journals/SR27.pdf";

  export const newsletter = [
    {
        id: 1, 
        img: WarsidahaCilmigaXoolaha2025, 
        fileUrl: A1
    },
  {
    id: 2,
    img: SSRN_IMG,
    fileUrl: SSRN_FILE
  },
    {
    id: 3,
    img: SR26G,
    fileUrl: SR26F
  },
   {
    id: 4,
    img: SR27G,
    fileUrl: SR27F
  },
  ]
